<template>
  <div class="port-listing doc-list">
    <div class="lead-listing">
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm: w-full md:w-1/3 mt-4 set_limit">
          <label class="limit_label">{{ $t("labels.show") }}</label>
          <v-select
            v-model="limit"
            :options="limitarr"
            :reduce="(limitarr) => limitarr.value"
            :clearable="false"
            label="text"
            class="px-1"
          />
          <label class="limit_label">{{ $t("labels.document_details") }}</label>
        </div>
        <div class="vx-col sm: w-full md:w-2/3">
          <div class="mt-4 admin-listing">
            <div class="filter">
              <router-link
                :to="{
                  name: 'AddDocument',
                  params: { id: this.$route.params.id },
                }"
              >
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="btn-add btn-color"
                  >{{ $t("labels.add_document") }}</vs-button
                >
              </router-link>
            </div>
            <div class="imp-exp">
              <vs-button
                color="warning"
                type="filled"
                class="btn-color sm: ml-0 md:ml-4 sm:px-6 md:px-10"
                icon-pack="feather"
                icon="icon-filter"
                @click="showfilter = !showfilter"
                >{{ $t("labels.filter") }}</vs-button
              >
              <vs-button
                color="dark"
                type="filled"
                class="btn-color ml-4 sm:px-6 md:px-10"
                icon-pack="feather"
                icon="icon-folder"
                @click="downloadZip()"
                >{{ $t("labels.zip") }}</vs-button
              >
            </div>
          </div>
        </div>
      </div>
      <vx-card class="filter-card filter_card mb-6" v-show="showfilter == true">
        <div class="vx-row filter-default">
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.search") }}</label>
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              v-model="search"
              class="w-full"
            />
          </div>

          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.document_type") }}</label>
            <v-select
              v-model="documentType"
              :options="filterdocumentType"
              :reduce="(filterdocumentType) => filterdocumentType.value"
              label="label"
              name="documentType"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-filter"
              :title="$t('labels.filter')"
              @click.prevent="filter()"
              :disabled="!this.search && !this.documentType"
              class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
              >{{ $t("labels.filter") }}</vs-button
            >
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-x"
              :title="$t('labels.filter')"
              @click="clearFilter()"
              :disabled="!this.search && !this.documentType"
              class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
              >{{ $t("labels.clear") }}</vs-button
            >
          </div>
        </div>
      </vx-card>
      <vs-table :data="documents" class="permission">
        <template slot="thead">
          <vs-th class="col-md-1"></vs-th>
          <vs-th class="col-md-2">{{ $t("labels.document_type") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.issuing_country") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.issuing_authority") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.number") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.issue_date") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.expiry_date") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.document_url") }}</vs-th>
          <vs-th class="col-md-1">{{ $t("labels.is_active") }}</vs-th>
          <vs-th class="pl-8 col-md-1">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="col-md-1">
              <!-- <input
                type="checkbox"
                class="mi-check-box"
                :value="tr.id"
                id="tr.id"
                v-model="documentIds"
                @change="zipDocuments(documentIds)"
              />-->
              <vs-checkbox
                :vs-value="tr.id"
                :id="tr.id"
                v-model="documentIds"
                @change="zipDocuments(documentIds)"
              ></vs-checkbox>
            </vs-td>
            <vs-td>{{ tr.document_name }}</vs-td>
            <vs-td v-if="tr.issuing_country_name">{{
              tr.issuing_country_name
            }}</vs-td>
            <vs-td v-else-if="!tr.issuing_country_name">-</vs-td>
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td v-if="tr.issuing_authority">{{
              tr.issuing_authority
            }}</vs-td>
            <vs-td v-else-if="!tr.issuing_authority">-</vs-td>
            <vs-td v-if="tr.number">{{ tr.number }}</vs-td>
            <vs-td v-else-if="!tr.number">-</vs-td>
            <vs-td v-if="tr.issue_date">{{
              tr.issue_date | only_date_format
            }}</vs-td>
            <vs-td v-else-if="!tr.issue_date">-</vs-td>
            <vs-td v-if="tr.expiry_date">{{
              tr.expiry_date | only_date_format
            }}</vs-td>
            <vs-td v-else-if="!tr.expiry_date">-</vs-td>
            <vs-td>
              <div class="doc-img">
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-if="tr.docType === 'image'"
                >
                  <img :src="tr.document_url" alt="Image" />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'word'"
                  class="file"
                >
                  <img src="./../../assets/images/pages/doc.svg" alt="Logo" />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'music'"
                  class="file"
                >
                  <img
                    src="./../../assets/images/pages/music-file.svg"
                    alt="Logo"
                  />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'pdf'"
                  class="file"
                >
                  <img src="./../../assets/images/pages/pdf.svg" alt="Logo" />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'csv'"
                  class="file"
                >
                  <img src="./../../assets/images/pages/csv.svg" alt="Logo" />
                </a>
                <a :href="tr.document_url" target="_blank" v-else class="file">
                  <img src="./../../assets/images/pages/txt.svg" alt="Logo" />
                </a>
              </div>
            </vs-td>
            <vs-td>
              <vs-switch
                v-model="tr.is_active"
                :value="tr.id"
                :id="tr.id"
                class="switch-container"
                @click="changeStatus(tr.id, tr.is_active)"
              />
            </vs-td>
            <vs-td width="135">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({
                      name: 'EditDocument',
                      params: { id: tr.id, user_id: tr.user_id },
                    })
                  "
                ></vs-button>
                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: [],
      documentIds: [],
      ports: [],
      documents: [],
      index: -1,
      totalPage: 1,
      country: 0,
      filterCountries: [],
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
      documentType: null,
      filterdocumentType: [
        { label: "Passport", value: "P" },
        { label: "Seamen book", value: "SB" },
        { label: "Visa", value: "V" },
        { label: "Other Documents", value: "O" },
      ],
    };
  },
  mounted() {
    this.$store.commit("UPDATE_CONSULTANT_TAB", 1);
    this.getDocuments();
  },
  watch: {
    limit(val) {
      this.currentx = 1;
      this.getDocuments();
    },
    currentx(val) {
      this.getDocuments();
    },
    documentIds(val) {},
  },
  methods: {
    zipDocuments(ids) {},
    async changeStatus(index, is_active) {
      let input = {
        id: index,
      };
      if (is_active === 0 || is_active === false) {
        input = Object.assign(input, {
          is_active: 1,
        });
      } else {
        input = Object.assign(input, {
          is_active: 0,
        });
      }
      if (this.$store.state.userInfo.type === "A") {
        input = Object.assign(
          {
            user_id: this.$route.params.id,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse(
        "/consultants/documents/change-status",
        input
      );
      if (response) {
      }
    },
    async downloadZip() {
      if (this.documentIds.length <= 0) {
        let error = "Please select Document!";
        this.$vs.notify({
          title: "Error.",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } else {
        this.$vs.loading();
        let input = {
          ids: this.documentIds,
        };
        if (this.$store.state.userInfo.type === "A") {
          input = Object.assign(
            {
              user_id: this.$route.params.id,
            },
            input
          );
        }
        this.axios
          .post("/consultants/download-zip", input, {
            responseType: "arraybuffer",
          })
          .then((response) => {
            let data = response.data;
            var currentDate = new Date();
            var formatted_date = new Date()
              .toJSON()
              .slice(0, 10)
              .replace(/-/g, "");
            let zipName =
              this.$store.state.userInfo.name + "_" + formatted_date;
            this.downloadZipFile(data, zipName);
            this.export = 0;
            this.$vs.loading.close();
            this.documentIds = [];
          })

          .catch((e) => {
            console.log("e", e);
          });
      }
    },
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deletePort,
      });
    },
    async deletePort() {
      if (this.index < 0) return;
      let url = "consultants/delete-documents";
      let ids = [];
      let index = this.index;
      ids.push(this.documents[index].id);
      let input = {
        ids: ids,
      };
      if (this.$store.state.userInfo.type === "A") {
        input = Object.assign(
          {
            user_id: this.$route.params.id,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getDocuments();
      }
    },
    async getDocuments(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        document_type: this.documentType,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      if (this.$store.state.userInfo.type === "A") {
        input = Object.assign(
          {
            user_id: this.$route.params.id,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse(
        "/consultants/list-documents",
        input
      );
      if (!exp) {
        if (response) {
          let data = response.data.documents;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          var docType = "";
          var documents = data;
          documents.forEach((doc) => {
            var extension = doc.document_url.split(".").pop();
            if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
              docType = "image";
              doc.docType = docType;
            }
            if (["doc", "docx"].includes(extension)) {
              docType = "word";
              doc.docType = docType;
            }
            if (["mp3", "wav"].includes(extension)) {
              docType = "music";
              doc.docType = docType;
            }
            if (["pdf"].includes(extension)) {
              docType = "pdf";
              doc.docType = docType;
            }
            if (["csv"].includes(extension)) {
              docType = "csv";
              doc.docType = docType;
            }
          });
          this.documents = data;
        }
      }
    },
    exportCsv() {
      this.getDocuments(true);
    },
    filter() {
      this.getDocuments();
    },
    clearFilter() {
      this.search = null;
      this.documentType = null;
      this.getDocuments();
    },
  },
};
</script>
<style scoped>
.doc-img img {
  height: 55px !important;
  border-radius: 3px;
  width: 70px !important;
  /* transition: transform 0.2s; */
}
/* .doc-img img:hover {
  height: 50px !important;
  transform: scale(2.5);
} */
</style>
